class aboutUsJS {
    constructor() {
    document.querySelectorAll("[data-slider-btn]").forEach(ele => {
        ele.addEventListener("click",()=>{
          document.body.classList.remove("scroll-fixed")
        });
    });

    document.body.addEventListener("click",(event)=>{
        let currentEle = event.target;
        if (currentEle.hasAttribute('data-slider-btn')) {
            return;
        }
        currentEle = currentEle.closest("[data-about-sidebar]");
            if(currentEle == null){
                document.querySelectorAll("[data-about-close-btn]").forEach(ele => {
                    ele.click();
                });
            }
        })
    }
}

new aboutUsJS();